import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { DialogClose } from "../ui/dialog";

const TextFormSchema = z.object({ value: z.string().nullable() });

interface TextFormProps {
	initialValue: string | null;
	onSubmit: (value: string | null) => void;
	label: string;
	submitButtonText: string;
}

export default function TextForm({
	initialValue,
	onSubmit,
	label,
	submitButtonText,
}: TextFormProps) {
	const form = useForm<z.infer<typeof TextFormSchema>>({
		resolver: zodResolver(TextFormSchema),
		defaultValues: { value: initialValue },
	});
	const submit = form.handleSubmit((data) => onSubmit(data.value || null));
	return (
		<Form {...form}>
			<form onSubmit={submit} className="space-y-4">
				<FormField
					control={form.control}
					name="value"
					render={({ field }) => (
						<FormItem>
							<FormLabel>{label}</FormLabel>
							<FormControl>
								<Input
									placeholder={`Enter ${label?.toLowerCase()}`}
									{...field}
									value={field.value ?? ""}
								/>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
				<DialogClose asChild>
					<Button type="submit" disabled={form.formState.isSubmitting}>
						{submitButtonText}
					</Button>
				</DialogClose>
			</form>
		</Form>
	);
}
